import * as yup from 'yup'

import { isPhoneNumberValid } from '@consumer/shared'

export const issueFormValidationSchema = yup.object().shape({
  trackingId: yup
    .string()
    .required('Please enter a valid tracking code')
    .test('valid-length', 'Please enter a valid tracking code', value => {
      if (!value) return false
      const trimmed = value.trim()
      return trimmed.length === 6 || trimmed.startsWith('VH')
    }),
  issueType: yup
    .string()
    .required('Please select an issue')
    .test(value => value !== 'selectAnIssue'),
  issueDetail: yup.string().max(500, 'Details must be 500 characters or less'),
  name: yup.string().required('Name is required'),
  email: yup.string().email('Please enter a valid email').required('Email is required'),
  cellPhone: yup
    .string()
    .required('Cell phone is required')
    .test('is-phone-number', 'Must be a valid phone number', value => isPhoneNumberValid(value)),
  consentChecked: yup.boolean().isTrue('You must consent to be contacted'),
})
